import React, { useEffect, useState } from "react";
import Mask_Group from "../assets/Mask group.svg";
import Grey_indicator from "../assets/Grey Indicator.svg";

const SavePopup = ({ open, onClose, token, queryDev, user_session_id, hasShouldCostSummary }) => {
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [responseData, setResponseData] = useState([]);
    const [error, setError] = useState(null);
    const [selectedRows, setSelectedRows] = useState([]);
    const [saveMessage, setSaveMessage] = useState("");
    const editableColumns = ["Negotiation_Status", "Negotiated_Price($)"];

    const generateReport = async () => {
        setLoading(true);
        setError(null);
        setResponseData([]);
        setSaveMessage("");

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append("query", "Retrieve data from spend data");
        formData.append("user_session_id", user_session_id);

        try {
            const res = await fetch(queryDev, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await res.json();
            const rawAnswer = data?.answer?.trim() || "";

            let cleaned = rawAnswer;
            if (cleaned.startsWith("```json")) {
                cleaned = cleaned.replace(/^```json/, "").replace(/```$/, "").trim();
            }

            const firstBrace = cleaned.indexOf("{");
            const lastBrace = cleaned.lastIndexOf("}");
            let parsed = null;

            if (firstBrace !== -1 && lastBrace !== -1) {
                parsed = JSON.parse(cleaned.slice(firstBrace, lastBrace + 1));
            }

            if (parsed?.type === "retrieve_data" && parsed?.response) {
                let finalData = parsed.response;

                // If response is a string, parse it again
                if (typeof finalData === "string") {
                    try {
                        finalData = JSON.parse(finalData);
                    } catch {
                        console.error("Failed to parse nested response JSON");
                    }
                }

                if (Array.isArray(finalData)) {
                    setResponseData(finalData);
                } else if (typeof finalData === "object") {
                    setResponseData([finalData]);
                } else {
                    setError("Unexpected response format");
                }
            } else {
                setError(data?.answer?.trim());
            }

        } catch (err) {
            console.error("Failed to retrieve data:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleRowSelect = (index) => {
        setSelectedRows((prev) =>
            prev.includes(index)
                ? prev.filter((i) => i !== index)
                : [...prev, index]
        );
    };

    const handleSaveSelected = async () => {
        if (selectedRows.length === 0) return;

        const selectedData = selectedRows.map((i) => responseData[i]);
        setSaving(true);
        setSaveMessage("");
        setError(null);

        const formData = new FormData();
        formData.append("operation", "query");
        formData.append(
            "query",
            `Save the data into dynamodb: ${JSON.stringify(selectedData)}`
        );
        formData.append("user_session_id", user_session_id);

        try {
            const res = await fetch(queryDev, {
                method: "POST",
                headers: { Authorization: `Bearer ${token}` },
                body: formData,
            });

            const data = await res.json();
            const rawAnswer = data?.answer?.trim() || "";

            let cleaned = rawAnswer;
            if (cleaned.startsWith("```json")) {
                cleaned = cleaned.replace(/^```json/, "").replace(/```$/, "").trim();
            }

            const firstBrace = cleaned.indexOf("{");
            const lastBrace = cleaned.lastIndexOf("}");
            let parsed = null;

            if (firstBrace !== -1 && lastBrace !== -1) {
                parsed = JSON.parse(cleaned.slice(firstBrace, lastBrace + 1));
            }

            if (parsed?.type === "memory_save_data" && parsed?.response) {
                setSaveMessage(parsed.response);
                setSelectedRows([]);
            } else {
                setError("Failed to save data. Please try again.");
            }
        } catch (err) {
            console.error("Save error:", err);
            setError("Something went wrong. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    useEffect(() => {
        if (open) {
            // 🔹 Reset all UI-related states when popup opens
            setError(null);
            setResponseData([]);
            setSelectedRows([]);
            setSaveMessage("");
            setSaving(false);
            setLoading(false);

            // 🔹 Only fetch if should cost summary is available
            if (hasShouldCostSummary) {
                generateReport();
            }
        }
    }, [open, hasShouldCostSummary]);


    if (!open) return null;

    const allKeys = responseData.length ? Object.keys(responseData[0]) : [];

    const handleCellChange = (rowIndex, key, newValue) => {
        setResponseData((prevData) => {
            const updated = [...prevData];
            updated[rowIndex] = { ...updated[rowIndex], [key]: newValue };
            return updated;
        });
    };


    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-white rounded-xl shadow-lg p-6 min-w-[400px] max-w-[900px] max-h-[85vh] overflow-y-auto relative">

                {!loading && (
                    <button
                        onClick={onClose}
                        className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
                    >
                        ✕
                    </button>
                )}
                {!hasShouldCostSummary ? (
                    <div className="text-[14px] text-gray-700">
                        ⚠️ Please generate the <b>Should Cost Summary</b> before saving workflow.
                    </div>
                ) : loading ? (

                    <div className="flex flex-col items-center justify-center text-gray-600">
                        <div className="relative w-10 h-10">
                            <img
                                src={Mask_Group}
                                alt="Mask_Group"
                                className="absolute w-full h-full animate-spin"
                            />
                            <img
                                src={Grey_indicator}
                                alt="Grey_indicator"
                                className="absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
                            />
                        </div>
                        <p className="mt-3">Retrieving the data, please wait...</p>
                    </div>
                ) : saving ? (
                    <div className="flex flex-col items-center justify-center text-gray-600">
                        <div className="relative w-10 h-10">
                            <img
                                src={Mask_Group}
                                alt="Mask_Group"
                                className="absolute w-full h-full animate-spin"
                            />
                            <img
                                src={Grey_indicator}
                                alt="Grey_indicator"
                                className="absolute top-1/4 left-1/4 w-1/2 h-1/2 animate-spin"
                            />
                        </div>
                        <p className="mt-3">Saving your selected information...</p>
                    </div>
                ) : error ? (
                    <div className="text-red-600 my-3 text-sm bg-red-50 border border-red-200 rounded p-3 whitespace-pre-wrap">
                        {error}
                    </div>
                ) : saveMessage ? (
                    <div
                        className={`font-medium my-2 text-[15px] text-center ${saveMessage.toLowerCase().includes("saved")
                            ? "text-green-700"
                            : "text-red-600"
                            }`}
                    >
                        {saveMessage}
                    </div>
                ) : Array.isArray(responseData) && responseData.length > 0 ? (
                    <div>
                        <p className="font-semibold text-[#7500c0] text-[14px] mb-3">
                            Choose one or more datasets to save your data successfully.
                        </p>

                        <div className="overflow-x-auto border rounded-lg">
                            
                            <table className="min-w-full border text-sm">
                                <thead>
                                    <tr className="bg-[#e6dcff]">
                                        <th className="p-2 border text-left">Select</th>
                                        {allKeys.map((key) => (
                                            <th key={key} className="p-2 border text-left">{key}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {responseData.map((item, index) => (
                                        <tr
                                            key={index}
                                            className={`hover:bg-[#f4f3ff] ${selectedRows.includes(index)
                                                ? "bg-[#f4f3ff]"
                                                : ""
                                                }`}
                                        >
                                            <td className="p-2 border text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(index)}
                                                    onChange={() => handleRowSelect(index)}
                                                />
                                            </td>
                                            {allKeys.map((key) => (
                                                <td key={key} className="p-2 border break-words">
                                                    {editableColumns.includes(key) ? (
                                                        <input
                                                            type={key === "Negotiated_Price($)" ? "number" : "text"}
                                                            value={item[key] ?? ""}
                                                            onChange={(e) => handleCellChange(index, key, e.target.value)}
                                                            className="w-full border !border-gray-400 rounded px-1 py-0.5 focus:outline-none focus:border-[#7500c0]"
                                                        />
                                                    ) : (
                                                        <span>{String(item[key] ?? "")}</span>
                                                    )}
                                                </td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>

                        </div>

                        <button
                            onClick={handleSaveSelected}
                            disabled={selectedRows.length === 0}
                            className={`mt-4 px-4 py-2 rounded-md text-white transition ${selectedRows.length > 0
                                ? "bg-[#a100ff] hover:bg-[#7500c0]"
                                : "bg-gray-400 cursor-not-allowed"
                                }`}
                        >
                            Save Selected Data ({selectedRows.length})
                        </button>
                    </div>
                ) : (
                    <div className="text-center p-4 my-3 bg-gray-50 border border-gray-200 rounded-md text-sm text-red-600 whitespace-pre-wrap">
                        {typeof responseData === "string"
                            ? responseData
                            : JSON.stringify(responseData, null, 2)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SavePopup;
